import { render, staticRenderFns } from "./info-screening-history.vue?vue&type=template&id=82dec7a4&scoped=true&"
import script from "./info-screening-history.vue?vue&type=script&lang=js&"
export * from "./info-screening-history.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-history.vue?vue&type=style&index=0&id=82dec7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dec7a4",
  null
  
)

export default component.exports